<template>
  <loading-component v-if="isLoading"/>
  <div class="columns is-multiline" v-else>
    <div class="column is-12 is-paddingless is-marginless has-text-left titleCard is-flex">
      <div>
        {{ detail.productName }} ({{ detail.name }}) -
        <span class="tag" :class="[
          detail.statusName == 'Pendiente' ? 'is-info' : '',
          detail.statusName == 'Preaprobado' ? 'is-warning' : '',
          detail.statusName == 'Activo' ? 'is-success' : '',
        ]">{{ detail.statusName }}</span>
      </div>
    </div>

    <div class="column is-12 separator"></div>

    <div class="column is-6">
      <div class="is-flex is-flex-direction-column gap">
        <div class="box">
          <p><strong>Calle:</strong> {{ data.street || 'N/A' }}</p>
          <p><strong>Colonia:</strong> {{ data.neighborhood || 'N/A' }}</p>
          <p><strong>Número externo:</strong> {{ data.exterior_number || 'N/A' }}</p>
          <p><strong>Número interno:</strong> {{ data.interior_number || 'N/A' }}</p>
          <p><strong>Ciudad:</strong> {{ data.city || 'N/A' }}</p>
          <p><strong>Código postal:</strong> {{ data.postal_code || 'N/A' }}</p>
          <p><strong>Creado el:</strong> {{ data.created_at ? formatDate(data.created_at) : 'N/A' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  components: {
    LoadingComponent: () => import('@/components/ui/Loading')
  },
  data () {
    return {
      isLoading: false,
      data: {}
    }
  },
  methods: {
    ...mapActions(['getAdminHomePickup']),

    formatDate (date) {
      return date ? new Date(date).toLocaleString() : 'Sin información'
    }
  },

  async beforeMount () {
    this.isLoading = true
    console.log('this.detail.productId', this.detail)
    let response = await this.getAdminHomePickup({ productId: this.detail.id })

    this.data = response

    this.isLoading = false
  }
}
</script>

<style>
.is-flex-direction-column {
  flex-direction: column;
}
.gap {
  gap: 10px;
}
</style>
